export interface Category {
  key: string;
  name: string;
  icon: string;
  desc: string;
  cover: string;
}

export const categories: Category[] = [
  {
    key: 'news',
    name: '资讯',
    icon: 'ri-newspaper-line',
    desc: '聚焦时政民生与城市发展，第一时间呈现权威、真实的最新动态与深度观察。',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20city%20government%20district%20with%20clean%20architecture%20and%20autumn%20trees%2C%20editorial%20news%20photography%2C%20soft%20natural%20light%2C%20calm%20professional%20tone&width=1200&height=675&seq=cat-news&orientation=landscape',
  },
  {
    key: 'entertainment',
    name: '娱乐',
    icon: 'ri-movie-line',
    desc: '网罗影视、音乐、综艺与潮流文化热点，带你轻松追上每一个话题风口。',
    cover:
      'https://readdy.ai/api/search-image?query=stylish%20cinema%20entrance%20with%20warm%20neon%20lights%20and%20red%20carpet%2C%20editorial%20entertainment%20photography%2C%20vibrant%20cozy%20atmosphere&width=1200&height=675&seq=cat-ent&orientation=landscape',
  },
  {
    key: 'tech',
    name: '科技',
    icon: 'ri-cpu-line',
    desc: '追踪人工智能、智能终端与前沿产业动态，解读科技如何改变日常。',
    cover:
      'https://readdy.ai/api/search-image?query=futuristic%20minimal%20technology%20workspace%20with%20circuit%20patterns%20and%20soft%20blue%20glow%2C%20clean%20editorial%20product%20photography&width=1200&height=675&seq=cat-tech&orientation=landscape',
  },
  {
    key: 'life',
    name: '生活服务',
    icon: 'ri-home-heart-line',
    desc: '实用生活指南与便民服务资讯，从健康到出行，让每一天都更从容。',
    cover:
      'https://readdy.ai/api/search-image?query=cozy%20warm%20family%20living%20room%20with%20plants%20and%20sunlight%2C%20lifestyle%20editorial%20photography%2C%20soft%20orange%20tones&width=1200&height=675&seq=cat-life&orientation=landscape',
  },
];

export interface HotTopic {
  id: string;
  label: string;
  heat: number;
  target: string;
}

export const hotTopics: HotTopic[] = [
  { id: 'h1', label: '城市更新行动', heat: 9821, target: '/special' },
  { id: 'h2', label: 'AI 智能助手', heat: 8760, target: '/category/tech' },
  { id: 'h3', label: '秋日养生指南', heat: 7932, target: '/category/life' },
  { id: 'h4', label: '国潮文化新风尚', heat: 7415, target: '/special' },
  { id: 'h5', label: '新能源购车攻略', heat: 6980, target: '/category/tech' },
  { id: 'h6', label: '秋季档观影推荐', heat: 6540, target: '/category/entertainment' },
  { id: 'h7', label: '一刻钟生活圈', heat: 6120, target: '/category/life' },
  { id: 'h8', label: '绿色低碳出行', heat: 5876, target: '/category/news' },
];